import styled, { css } from 'styled-components';

export const TableCellRoot = styled.td`
	display: table-cell;
	vertical-align: inherit;
	border-bottom: 1px solid rgba(224, 224, 224, 1);
	text-align: ${(props) => props.align ? props.align : 'left'};
	padding: ${(props) => props.padding ? props.padding : '16px'};
	width: ${(props) => props.width ? props.width : 'auto'};
	background-color: ${(props) => props.theme === 'dark' ? '#f2f2f2' : '#fff'};
	position: ${(props) => props.position ? props.position : 'static'};
	&.report_table{
		background-color:#FAFAFA;
	}
	${
	(props) => props.variant === 'head' && css`
			font-size: 12px;
			font-weight: 900;
			color: #747474;
	`
}
    ${
	(props) => props.variant === 'body' && css`
		color: #351e2e;
		font-weight: 400;
`
}
    ${
	(props) => props.variant === 'child' && css`
		background-color: #fafafa;
`
}
${
	(props) => props.noBdr && css`
		border-bottom:none;
`
}
    ${
	(props) => props.variant === 'footer' && css`
		font-weight: 400;
		line-height: 1.43;
`
}
    ${
	(props) => props.size === 'small' && css`
		padding: 6px 16px;
`
}
    ${
	(props) => props.padding === 'checkbox' && css`
	width: 48;
	padding: 0 0 0 4px;
	`
}
    ${
	(props) => props.padding === 'none' && css`
		padding: 0px;
	`
}
${(props) => props.disabled && css`
			position: relative;
			&:after {
				content: '';
				top: 0;
				left: 0;
				position: absolute;
				height: 100%;
				width: 100%;
				z-index: 1;
				background: #fff;
				opacity: 0.6;
				cursor: not-allowed;
			}
		`}
${
	(props) => props.stickyHeader && css`
		position: sticky;
		top: 0;
		left: 0;
		z-index: 1;
	`
}
`;
